import koreaMapDataJson from '@/assets/data/Korea.json'
import defaultSettings from '@/assets/js/mapOption'
import { Map } from '@/assets/js/map'
import mapApi from '@/api/web/MapApi'
import { mapGetters } from 'vuex'

const mapOptionStore = 'mapOptionStore'
const statItemStore = 'statItemStore'

export default {
  props: {
    mapId: String,
    mapType: String,
    mapYear: String
  },
  data: function () {
    return {
      mapView: new Map(),
      mapLayerList: [],
      mapInfoWindowList: [],
      mapStatItems: [],
      mapStatItemYearList: [],
      showInfoWindowCode: '',
      isMapPopupViewAllType: false
    }
  },

  computed: {
    ...mapGetters(mapOptionStore, {
      getMapStyle: 'getMapStyle',
      getMapDefaultStyle: 'getMapDefaultStyle',
      getFillOpacity: 'getFillOpacity',
      getRegionalColor: 'getRegionalColor',
      getHeatMapColor: 'getHeatMapColor',
      getMapPopupViewType: 'getMapPopupViewType'
    }),

    ...mapGetters(statItemStore, {
      selectedStatItems: 'selectedStatItems',
      statItemYearInfoWindowMaxCount: 'statItemYearInfoWindowMaxCount',
      selectedYearList: 'selectedYearList'
    })
  },

  watch: {
    getFillOpacity (value) {
      let isDefaultStyle = true
      if (this.selectedStatItems.length > 0 || this.selectedYearList.length > 0) {
        isDefaultStyle = false
      }

      for (const layerIdx in this.mapLayerList) {
        const layer = this.mapLayerList[layerIdx]

        if (isDefaultStyle) {
          layer.setStyle({ fillOpacity: this.getMapDefaultStyle.fillOpacity })
        } else {
          layer.setStyle({ fillOpacity: value })
        }
      }
    },
    getMapPopupViewType (value) {
      // console.log('getMapPopupViewType...', value)
      if (value === defaultSettings.map.options.showPopupDataViewType.all) {
        this.isMapPopupViewAllType = true
      } else {
        this.isMapPopupViewAllType = false
      }

      if (this.isMapPopupViewAllType) {
        this.showAllLayerInfoWindow()
      } else {
        this.removeAllLayerInfoWindow()
      }
    },
    getHeatMapColor (value) {
      this.showMapStatDataInfoWindow()
    }
  },

  created () {
    if (this.getMapPopupViewType === defaultSettings.map.options.showPopupDataViewType.all) {
      this.isMapPopupViewAllType = true
    } else {
      this.isMapPopupViewAllType = false
    }
  },

  mounted: function () {
    this.mapView.createMap(this.mapId, this)
    this.mapView.setPolygonGeoJson(koreaMapDataJson, this.onEachFeature, null)

    this.initMap()
  },

  methods: {
    initMap () {
      this.mapView.removeAllAddPolygonLayer()
      this.resetMap()

      if (this.mapType === this.$mapType.SI_GUN_GU) {
        this.mapView.setPolygonGeoJsonStyle(this.getMapStyle)
      } else {
        this.mapView.setPolygonGeoJsonStyle(this.getMapDefaultStyle)
      }
    },

    // 지도 기본 레이어 기능 설정
    onEachFeature (feature, layer) {
      const mapLayerInfoWindow = {
        adm_cd: layer.feature.properties.adm_cd,
        adm_nm: layer.feature.properties.adm_nm,
        infoWindow: this.mapView.sop.infoWindow({
          closeButton: false,
          closeOnClick: false
        })
      }
      this.mapInfoWindowList.push(mapLayerInfoWindow)
      this.mapLayerList.push(layer)

      layer.on({
        click: (event) => {
          this.onLayerClick(feature, layer, event)
        },
        mousemove: (event) => {
          this.onMouseEvent(event.type, event.utmk, event.target.feature.properties.adm_cd)
        },
        mouseover: (event) => {
          this.onMouseEvent(event.type, event.utmk, event.target.feature.properties.adm_cd)
        },
        mouseout: (event) => {
          this.onMouseEvent(event.type, event.utmk, event.target.feature.properties.adm_cd)
        }
      })
    },

    onMouseEvent (type, layerPoint, admCd) {
      if (this.getMapPopupViewType === defaultSettings.map.options.showPopupDataViewType.all) {
        return
      }

      if (this.mapInfoWindowList === undefined || this.mapInfoWindowList.length === 0 || this.selectedStatItems.length === 0) {
        return
      }

      if (type === 'mouseout') {
        const infoWindow = this.getLayerInfoWindow(admCd)
        if (infoWindow != null) {
          this.mapView.myMap.closeInfoWindow(infoWindow)
        }
      } else if (type === 'mouseover') {
        const infoWindow = this.getLayerInfoWindow(admCd)
        if (infoWindow != null) {
          infoWindow.setUTMK([layerPoint.x, layerPoint.y + 10000])
          infoWindow.addTo(this.mapView.myMap)

          this.showInfoWindowCode = admCd
        }

      } else if (type === 'mousemove') {
        if (this.showInfoWindowCode === admCd) {
          const infoWindow = this.getLayerInfoWindow(admCd)
          if (infoWindow != null) {
            infoWindow.setUTMK([layerPoint.x, layerPoint.y + 10000])
            // infoWindow.addTo(this.mapView.myMap)
          }
        }
      }
    },

    // 지도 상세(시군구) 레이어 기능 설정
    onDetailEachFeature (feature, layer) {
      layer.on({
        click: (event) => {
          this.onDetailLayerClick(layer, event)
        // },
        // mouseover: (event) => {
        //   console.log('onDetailEachFeature 마우스 들어 나갔음..')
        // },
        // mouseout: (event) => {
        //   console.log('onDetailEachFeature 마우스 들어 왔음..')
        }
      })
    },

    // 지도 레이어 및 InfoWindow 초기화
    resetMap () {
      for (const layerIdx in this.mapLayerList) {
        const layer = this.mapLayerList[layerIdx]
        layer.setStyle(this.getMapDefaultStyle)
        this.mapView.myMap.closeInfoWindow(this.getLayerInfoWindow(layer.feature.properties.adm_cd))
      }
    },

    // 전국 시도별 통계 데이터 InfoWindows 표시
    showMapStatDataInfoWindow () {
      const params = []
      for (const mapItemData of this.mapStatItems) {
        const statItemParam = {
          mapSysNo: mapItemData.mapSysNo,
          mapItmNo: mapItemData.info.mapItmNo,
          years: mapItemData.years
        }
        params.push(statItemParam)
      }

      let layerColors = defaultSettings.map.heatColor[this.getHeatMapColor]
      let isHeatMapType = true

      if (this.mapStatItemYearList.length > 1) {
        isHeatMapType = false
        layerColors = defaultSettings.map.color.defaultRegionalColors
      }

      mapApi.searchMapInfoWindow(params).then(resultData => {
        const apInfoWindowDataList = resultData
        let mapLayerColor = ''
        for (const idx in apInfoWindowDataList) {
          const infoData = apInfoWindowDataList[idx]

          for (const layerIdx in this.mapLayerList) {
            const layer = this.mapLayerList[layerIdx]

            if (infoData.sidoId === layer.feature.properties.adm_cd) {
              if (isHeatMapType) {
                // mapLayerColor = defaultSettings.map.heatColor[this.getHeatMapColor][Math.floor(idx / 4)]
                mapLayerColor = layerColors[Math.floor(idx / 4)]
              } else {
                // console.log('+++++++++++++++++++++++++++')
                // console.log(layer.feature.properties.adm_cd, typeof layer.feature.properties.adm_cd)
                // console.log('+++++++++++++++++++++++++++')
                // mapLayerColor = this.getRegionalColor(layer.feature.properties.adm_cd)
                mapLayerColor = layerColors[layer.feature.properties.adm_cd]
              }

              layer.setStyle({
                fillColor: mapLayerColor,
                opacity: 1,
                fillOpacity: this.getFillOpacity
              })

              let contentsInfoHTML = ''
              infoData.values.forEach(element => {
                contentsInfoHTML +=
                  '<tr>' +
                  '<td><span>' + element.year + '</span></td>' +
                  '<td>' + element.mapItmNm + '</td>' +
                  '<td>' + element.itmValue + element.unitNm + '</td>' +
                  '</tr>'
              })

              const contents = '' +
                '<table>' +
                '<tbody>' +
                '<tr>' +
                '<th colspan="3">' + infoData.siNm + '</th>' +
                '</tr>' +
                contentsInfoHTML +
                '</tbody>' +
                '</table>'

              const infoWindow = this.getLayerInfoWindow(layer.feature.properties.adm_cd)

              const utmkXY = new window.sop.LatLng(infoData.latitude, infoData.longitude)
              infoWindow.setUTMK([utmkXY.x, utmkXY.y])
              infoWindow.setContent(contents)

              if (this.isMapPopupViewAllType) {
                infoWindow.addTo(this.mapView.myMap)
              }
              break
            }
          }
        }
        this.mapView.setView(this.mapView.center, this.mapView.baseZoom)
      })
    },

    // 전국 시도별 지도 레이어 표시
    showMapKoreaAreaLayer () {
      const layerColors = defaultSettings.map.color.defaultRegionalColors
      for (const layerIdx in this.mapLayerList) {
        const layer = this.mapLayerList[layerIdx]
        layer.setStyle({
          fillColor: layerColors[layer.feature.properties.adm_cd],
          opacity: 1,
          fillOpacity: 1
        })

        this.mapView.myMap.closeInfoWindow(this.getLayerInfoWindow(layer.feature.properties.adm_cd))
      }
    },

    // 지도 레이어 속한 InfoWindow 반환
    getLayerInfoWindow (admCd) {
      for (const infoWindow of this.mapInfoWindowList) {
        if (admCd === infoWindow.adm_cd) {
          return infoWindow.infoWindow
        }
      }
      return null
    },

    onLayerClick (feature, layer, event) {
      if (this.mapType === this.$mapType.SI_GUN_GU) {
        this.mapView.setView([feature.properties.x, feature.properties.y], 3)

        this.searchSido(event.target.feature.properties.adm_cd)
      } else {
        this.showDetailDataBoard(event.target.feature.properties.adm_nm, event.target.feature.properties.adm_cd)
      }
    },

    onDetailLayerClick (layer, event) {
      if (this.mapType === this.$mapType.SI_GUN_GU) {
      }
    },

    searchSido (admCd) {
      this.mapView.removeAllAddPolygonLayer()

      mapApi.searchSiDo(admCd).then(res => {
        this.mapView.addPolygonGeoJson(res.data, this.onDetailEachFeature, this.getMapStyle)
      })
    },

    showAllLayerInfoWindow () {
      if (this.selectedStatItems.length > 0) {
        for (const infoWindow of this.mapInfoWindowList) {
          infoWindow.infoWindow.addTo(this.mapView.myMap)
        }
      }
    },

    removeAllLayerInfoWindow () {
      if (this.selectedStatItems.length > 0) {
        for (const infoWindow of this.mapInfoWindowList) {
          if (infoWindow != null) {
            this.mapView.myMap.closeInfoWindow(infoWindow.infoWindow)
          }
        }
      }
    }
  }
}
